import { To } from 'react-router-dom';

/**
 * Prepares navigation route while persisting query params.
 * @param path destination path, could be relative or absolute as accepted by React-Route v6.
 */
export const getToRoute = (path: string): To => ({
    pathname: path,
    search: getWindow().location.search,
});

export const getWindow = (): Window => window;
